module.exports = __webpack_public_path__ + "static/media/darkrporter.a459d789.jpeg";